import React, { Component } from 'react';
import './logoSection.css';
import MaterialIcon from 'material-icons-react';
import {Colors} from './../../utils/constants';
import DesignSection from './designSection';
import SectionBanner from './sectionBanner';
import SectionPageHeader from './sectionPageHeader';

const improperLogoNumbers = [1, 2, 3, 4, 5, 6, 7, 8];

export default class LogoSection extends Component {
  render() {
    return (
      <div className="sectionContainer full-width">
        <SectionBanner image="/images/background-lines-gradient-purple.webp" title="Company Logos" />
        <SectionPageHeader description="Our logo is our most important brand asset and the foundation of our visual identity. Using it consistently and according to our guidelines ensures we stand out and build cohesive, recognizable branding across all materials." />
        <DesignSection
          title={'Usage Guidelines'}
          subtitle={'Apply these rules consistently across all YipitData brand logos — YipitData, Spendhound, and Signals.'}>
          {[
            {
              doContent: (
                <div style={{ background: '#0D4753', height: '180px', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src="/images/logo-light.png" style={{ width: '60%' }} />
                </div>
              ),
              doLabel: 'Use the white logo on dark or colored backgrounds.',
              dontContent: (
                <div style={{ background: '#1a1a1a', height: '180px', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src="/images/logo-dark.png" style={{ width: '60%' }} />
                </div>
              ),
              dontLabel: 'Never use the color logo on a dark background.',
            },
            {
              doContent: (
                <div style={{ background: '#f7f7f7', height: '180px', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src="/images/logo-dark.png" style={{ width: '60%' }} />
                </div>
              ),
              doLabel: 'Use the color logo on white or light neutral backgrounds.',
              dontContent: (
                <div style={{ background: 'linear-gradient(135deg, #F48D5C, #f5b98a)', height: '180px', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src="/images/logo-dark.png" style={{ width: '60%' }} />
                </div>
              ),
              dontLabel: 'Never place the color logo on a busy or colored background.',
            },
            {
              doContent: (
                <div style={{ background: '#f7f7f7', height: '180px', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src="/images/logo-dark.png" style={{ width: '60%' }} />
                </div>
              ),
              doLabel: 'Keep the logo clean, flat, and unmodified.',
              dontContent: (
                <div style={{ background: '#f7f7f7', height: '180px', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src="/images/logo-dark.png" style={{ width: '60%', filter: 'drop-shadow(0 0 12px rgba(0,110,133,0.9)) drop-shadow(0 0 24px rgba(0,110,133,0.5))' }} />
                </div>
              ),
              dontLabel: "Never add drop shadows, outlines, glows, or other effects to the logo.",
            },
          ].map((pair, i) => (
            <div className="row tiny-bottom-margin" key={i}>
              <div className="small-12 medium-6 small-padding">
                <div style={{ border: '2px solid #4CAF50', borderRadius: '8px', overflow: 'hidden' }}>
                  {pair.doContent}
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '6px', marginTop: '8px' }}>
                  <span className="material-symbols-rounded" style={{ color: '#4CAF50', fontSize: '18px', marginTop: '2px', fontVariationSettings: "'FILL' 1" }}>check_circle</span>
                  <p style={{ margin: 0, fontSize: '0.85rem' }}>{pair.doLabel}</p>
                </div>
              </div>
              <div className="small-12 medium-6 small-padding">
                <div style={{ border: '2px solid #ED4843', borderRadius: '8px', overflow: 'hidden' }}>
                  {pair.dontContent}
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '6px', marginTop: '8px' }}>
                  <span className="material-symbols-rounded" style={{ color: '#ED4843', fontSize: '18px', marginTop: '2px', fontVariationSettings: "'FILL' 1" }}>cancel</span>
                  <p style={{ margin: 0, fontSize: '0.85rem' }}>{pair.dontLabel}</p>
                </div>
              </div>
            </div>
          ))}
        </DesignSection>

        <DesignSection
          title={'Clear Space'}
          subtitle={'Always maintain a minimum amount of clear space around the logo. This prevents it from feeling crowded and ensures it reads clearly in any context. The minimum clear space on all sides should equal approx the height of the logo mark.'}>
          <p className="primary-color-dark" style={{ margin: 0, fontSize: '0.85rem' }}><b>{'Note: '}</b>{'The dashed boundary marks the minimum exclusion zone. No other text, graphic, or design element should appear within this protected area.'}</p>
          <div className="small-padding" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '12px' }}>
            <div style={{ position: 'relative', display: 'inline-flex', padding: '44px' }}>
              <div style={{ display: 'inline-flex', borderRadius: '8px', position: 'relative', border: '2px dashed #4CAF50' }}>
                <div style={{ position: 'absolute', inset: '-44px', border: '2px dashed #4CAF50', borderRadius: '8px', pointerEvents: 'none' }} />
                <img src="/images/logo-dark.png" style={{ width: '310px', display: 'block', marginTop: '-16px', marginBottom: '-18px', marginLeft: '-8px', marginRight: '-8px' }} />
              </div>
            </div>
          </div>
        </DesignSection>

        <DesignSection
          title={'YipitData Logo'}>
          <div className="">
              <div className="row middle centered-text">
                <div className="small-12 medium-6 small-padding">
                  <div className="shadow centered-text small-padding primary-background-dark" style={{borderRadius:'8px', minHeight:'220px', display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <img src={'/images/logo-light.png'} className="three-quarter-width" />
                  </div>
                  <div className="small-padding centered-text">
                    <a href="/design/yipitdata-logo-white.zip" download="yipitdata-logo-white.zip">
                      <div className="button primary-background white">{'Download'}<span className="material-symbols-rounded">download</span></div>
                    </a>
                  </div>
                </div>
                <div className="small-12 medium-6 small-padding">
                  <div className="shadow centered-text small-padding" style={{borderRadius:'8px', minHeight:'220px', display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <img src={'/images/logo-dark.png'} className="three-quarter-width" />
                  </div>
                  <div className="small-padding centered-text">
                    <a href="/design/yipitdata-logo-dark.zip" download="yipitdata-logo-dark.zip">
                      <div className="button primary-background white">{'Download'}<span className="material-symbols-rounded">download</span></div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
        </DesignSection>
        <DesignSection
          title={'Spendhound Logo'}>
          <div className="">
              <div className="row middle centered-text">
                <div className="small-12 medium-6 small-padding">
                  <div className="shadow centered-text small-padding spendhound-primary-background" style={{borderRadius:'8px', minHeight:'220px', display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <img src={'/images/spendhound-logo-light.png'} className="three-quarter-width" />
                  </div>
                  <div className="small-padding centered-text">
                    <a href="/design/spendhound-logo-white.zip" download="spendhound-logo-light.zip">
                      <div className="button spendhound-primary-background white">{'Download'}<span className="material-symbols-rounded">download</span></div>
                    </a>
                  </div>
                </div>
                <div className="small-12 medium-6 small-padding">
                  <div className="shadow centered-text small-padding" style={{borderRadius:'8px', minHeight:'220px', display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <img src={'/images/spendhound-logo-dark.png'} className="three-quarter-width" />
                  </div>
                  <div className="small-padding centered-text">
                    <a href="/design/spendhound-logo-dark.zip" download="spendhound-logo-dark.zip">
                      <div className="button spendhound-primary-background white">{'Download'}<span className="material-symbols-rounded">download</span></div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
        </DesignSection>
        <DesignSection
          title={'Signals Logo'}>
          <div className="medium-bottom-margin">
              <div className="row middle centered-text">
                <div className="small-12 medium-6 small-padding">
                  <div className="shadow centered-text small-padding signals-primary-background" style={{borderRadius:'8px', minHeight:'220px', display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <img src={'/design/signals-logo-light.png'} className="three-quarter-width" />
                  </div>
                  <div className="small-padding centered-text">
                    <a href="/design/signals-logo-white.zip" download="signals-logo-light.zip">
                      <div className="button signals-primary-background white">{'Download'}<span className="material-symbols-rounded">download</span></div>
                    </a>
                  </div>
                </div>
                <div className="small-12 medium-6 small-padding">
                  <div className="shadow centered-text small-padding" style={{borderRadius:'8px', minHeight:'220px', display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <img src={'/design/signals-logo-dark.png'} className="three-quarter-width" />
                  </div>
                  <div className="small-padding centered-text">
                    <a href="/design/signals-logo-dark.zip" download="signals-logo-dark.zip">
                      <div className="button signals-primary-background white">{'Download'}<span className="material-symbols-rounded">download</span></div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
        </DesignSection>
              

      </div>
    );
  }
}
